"use client";

import { useTriggerAction, type BlokAction } from "@/lib/action-link";
import { regionFromPathname } from "@/lib/region";
import { resolveLink, type StoryblokLink } from "@/lib/storyblok-link";
import { usePublicPathname } from "@/lib/public-pathname";

type HeroReviewCtaProps = {
  label?: string;
  link?: StoryblokLink;
  action?: BlokAction | "";
  onDark: boolean;
};

export default function HeroReviewCta({ label, link, action, onDark }: HeroReviewCtaProps) {
  const region = regionFromPathname(usePublicPathname());
  const resolved = resolveLink(link, region);
  const triggerAction = useTriggerAction();
  const act = action || null;

  if (!label || (!act && resolved.href === "#")) return null;

  const className = `mt-2 inline-flex h-14 w-fit items-center justify-center rounded-[8px] px-7 text-base font-bold transition-colors lg:text-lg ${
    onDark
      ? "bg-white text-navy-03 hover:bg-teal-03"
      : "bg-brand-orange-02 text-white hover:bg-brand-orange-03"
  }`;

  if (act) {
    return (
      <button
        type="button"
        onClick={(e) => triggerAction(act, e)}
        className={`cursor-pointer ${className}`}
      >
        {label}
      </button>
    );
  }

  return (
    <a
      href={resolved.href}
      {...(resolved.target ? { target: resolved.target } : {})}
      className={className}
    >
      {label}
    </a>
  );
}
